import React from 'react';

import { Portal } from '../../components';
import { PresetViewsPickerContainer } from './preset-views-picker';

interface PresetViewsPickerProps {
	path: string;
}

export const PresetViewsPickerPortal = ({ path }: PresetViewsPickerProps) => {
	return <Portal element={<PresetViewsPickerContainer path={path} />} nodeId="preset-views-picker-portal" />;
};
